import useAppStore from '../store/rootStore';
import { useHeartbeatStore } from '@/common/heartbeatStore.ts';

export function useIsOneClickEnabled(): boolean {
  const isOneClickEnabled = useAppStore((state) => state.account?.fw ?? false);
  const heartbeatAlive = useHeartbeatStore((state) => !state.isIndexingFarBehind);

  return isOneClickEnabled && heartbeatAlive;
}
